<template lang="html">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="none">
    <path d="M6.54474 5.84085C6.54474 7.4475 5.2423 8.74994 3.63565 8.74994C2.02901 8.74994 0.726562 7.4475 0.726562 5.84085C0.726562 4.23421 2.02901 2.93176 3.63565 2.93176C5.2423 2.93176 6.54474 4.23421 6.54474 5.84085Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke="var(--Shades-00)"/>
    <path d="M15.2733 5.84085C15.2733 7.4475 13.9708 8.74994 12.3642 8.74994C10.7575 8.74994 9.45508 7.4475 9.45508 5.84085C9.45508 4.23421 10.7575 2.93176 12.3642 2.93176C13.9708 2.93176 15.2733 4.23421 15.2733 5.84085Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke="var(--Shades-00)"/>
    <path d="M6.54474 5.84091C6.54474 5.45514 6.69799 5.08517 6.97077 4.81239C7.24355 4.53961 7.61352 4.38636 7.99929 4.38636C8.38506 4.38636 8.75503 4.53961 9.02781 4.81239C9.30059 5.08517 9.45384 5.45514 9.45384 5.84091M0.726562 5.84091L1.45384 0.75H3.63565M15.272 5.84091L14.5447 0.75H12.3629" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke="var(--Shades-00)"/>
  </svg>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: 'IconDiopter'
}
</script>
